module.exports = __webpack_public_path__ + "img/detail-website.12d9e785.svg";